import { render, staticRenderFns } from "./ComplaintTypeLabel.vue?vue&type=template&id=44b9cec9"
import script from "./ComplaintTypeLabel.vue?vue&type=script&lang=js"
export * from "./ComplaintTypeLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports